var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dark"},[_c('h1',{staticClass:"text-light title"},[_vm._v(" LEADER IN TICKETING - YOUR GUIDE TO GOING OUT ")]),_c('div',{staticClass:"events-section"},_vm._l((_vm.filteredEvents),function(event,index){return _c('div',{key:index,staticClass:"item"},[_c('router-link',{staticClass:"card",attrs:{"to":{
          name: 'ItemDetails',
          params: {
            event: event,
            id: event.id,
          },
        }}},[_c('img',{staticClass:"card-image",attrs:{"src":event.img}}),_c('div',{staticClass:"card-bottom shadow text-light"},[_c('p',{staticClass:"item-title m-auto"},[_vm._v(" "+_vm._s(event.name)+" ")])])])],1)}),0),_c('ItemList',{attrs:{"events":_vm.events}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }